import axios from 'axios';
import { useToast } from 'vue-toastification';

const toast = useToast();


const state = {
    notifications: null,
    notification: null
};

const getters = {
    stateNotifications: state => state.notifications,
    stateNotification: state => state.notification,
};

const actions = {
    // eslint-disable-next-line no-empty-pattern
    async createNotification({}, notification) {
        await axios.post('notifications/add', notification);
        //await dispatch('getNotifications', notification.proceeding_id);
        toast.success('Se ha creado la notificación');
    },
    async getNotifications({commit}, id) {
        let {data} = await axios.get(`notifications/get_by_proceeding_id/${id}`);
        commit('setNotifications', data);
    },
    async viewNotification({commit}, id) {
        let {data} = await axios.get(`notifications/get/${id}`);
        commit('setNotification', data);
    },
    // eslint-disable-next-line no-empty-pattern
    async updateNotification({},notification) {
        try {
            await axios.put(`notifications/update/${notification.id}`, notification.form);
            toast.success('Se ha actualizado la notificación');
        } catch (error) {
            console.error('Error updating notification:', error);
            toast.error('Error al actualizar la notificación');
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteNotification({}, id) {
        await axios.delete(`notifications/delete/${id}`);
        toast.success('Se ha eliminado la notificación');
    }
};

const mutations = {
    setNotifications(state, notifications){
        state.notifications = notifications;
    },
    setNotification(state, notification){
        state.notification = notification;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
